export default __webpack_public_path__ + "d33a38c.png";